module.exports = "https://cdn.realtymogul.com/static/media/icon_webinar.c0b54828.svg";